import { useEffect } from "react";

import { useHref, useLocation, useNavigationType } from "react-router-dom";

import { Outlet } from "react-router-dom";

import { logDebug } from "../../../utils/logger";

const RouterLayout = () => {
  const url = useHref();
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    logDebug("RouterLayout", "router", {
      url: url,
      type: navigationType,
      location: { ...location },
    });
  }, [url, navigationType, location]);

  return <Outlet />;
};

export default RouterLayout;
